import { scrollRunwayCss } from '@/lib/scroll-runway';

/**
 * `useVerticalScrollCarousel` is given a weight of 2 for every transition — see
 * `buildStepWeights` in `client.tsx`.
 */
export const SCROLL_WEIGHT_PER_CARD = 2;

/**
 * Measured heights of the mobile sticky card. It is content-driven, so it steps at the same
 * container breakpoints the section is styled against (`@xs` 384px, `@md` 768px):
 * 703px below `@xs`, 775px up to `@md`, 896px up to `@lg`.
 *
 * The runway has to be reserved by the server render. The Suspense fallback cannot know
 * `isMobile` — it is resolved by `useIsMobile` on the client — so it previously reserved
 * nothing at all and the section grew by its whole runway the moment the client mounted.
 * Expressing the card height as a CSS variable lets the fallback reserve it without knowing
 * the viewport, and `@lg:h-auto` drops it on desktop, where the sticky goes `@lg:relative`
 * and no runway exists. See JLG4-239.
 */
export const MOBILE_CARD_HEIGHT_VARS =
  '[--recover-card-height:703px] @xs:[--recover-card-height:775px] @md:[--recover-card-height:896px]';

/**
 * Seeds `stickyContainerHeight` for the one client render before the measuring effect reads
 * the real `offsetHeight`. It is a *card* height, not a runway — the previous 2100 conflated
 * the two.
 */
export const STICKY_CARD_HEIGHT = 896;

export function mobileScrollRunway(cardCount: number): string {
  const totalWeight = SCROLL_WEIGHT_PER_CARD * Math.max(0, cardCount - 1);
  return scrollRunwayCss('var(--recover-card-height)', totalWeight);
}
